import { Component, DestroyRef, ElementRef, inject, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild, effect } from '@angular/core';
import { FeedsService } from 'src/app/shared/services/feeds/feeds.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { LtmsEventHandlerService } from 'src/app/shared/services/ltms-event-handler/ltms-event-handler.service';
import { LoginService } from 'src/app/shared/services/login/login.service';
import { AccountsService } from 'src/app/shared/services/accounts/accounts.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { ManagersService } from '../../services/managers/managers.service';
import { GlobalFilterService } from '../../services/filters/global-filter.service';
import { APP_CONST } from '../../constants/app-constants';
import * as _ from 'lodash';
import * as moment from 'moment';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { extendedRaterFile } from "src/app/shared/services/external-ts-files/extended-rating-mapper";
import { NgIf, NgFor, DecimalPipe, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { LtmsDataTableV2Component } from '../ltms-data-table-v2/ltms-data-table-v2.component';
import { LtmsLoaderComponent } from '../ltms-loader/ltms-loader.component';
import { FeedDetailPanelComponent } from '../feed-detail-panel/feed-detail-panel.component';
import { LitmusResponseDownloaderComponent } from '../litmus-response-downloader/litmus-response-downloader.component';
import { TranslateModule } from '@ngx-translate/core';

interface Project {
  name: string;
  doc_count: number;
  last_response_received_at: Date;
}

@Component({
  selector: 'litmus-feed-list-view',
  templateUrl: './litmus-feed-list-view.component.html',
  styleUrl: './litmus-feed-list-view.component.scss',
  imports: [NgIf, NgFor, FormsModule, NgbTooltip, LtmsDataTableV2Component, LtmsLoaderComponent, FeedDetailPanelComponent, LitmusResponseDownloaderComponent, DecimalPipe, DatePipe, TranslateModule]
})
export class LitmusFeedListViewComponent implements OnInit, OnChanges {
  @ViewChild('litmussearchdropdown') litmusfeedsearch!: ElementRef;
  @ViewChild('ltmsgridsortdd') ltmsgridsortdd!: ElementRef;
  @ViewChild('feedlistview') feedlistview!: TemplateRef<any>;
  @ViewChild('leftControls', { static: false }) leftControls!: ElementRef;
  @Input() isAccountFeeds: boolean = false;
  fullScreenComponent: TemplateRef<any> | null = null;
  destroyRef = inject(DestroyRef);
  desclaimer: string = 'Get a complete picture of all user feedback across projects. Track response volume, latest activity, and easily filter for deep analysis and trend spotting.';
  projectLevelDesclaimer: string = 'View individual conversation responses with details and options for action (assignment, tracking, etc.). Leverage automations to streamline feedback management and boost efficiency. Click any response for more info.';
  univeralFilterMap: any = {
    "status": "action_filter.status_id_list",
    "category": "action_filter.category_id_list",
    "assignee": "action_filter.assigned_to_id_list",
    "tag": "action_filter.tag_id_list",
    "tat_status_closed": "action_filter.tat_status_list"
  }
  brandFilterMap: any = {
    "status": {
      key: "status_list",
      uniqueField: "uuid"
    },
    "category": {
      key: "category_list",
      uniqueField: "uuid"
    },
    "tag": {
      key: "tag_list",
      uniqueField: "uuid"
    }
  }
  limit: number = 10;
  filters: any = {}
  dateFilterType: number = 1
  fromDate: any;
  toDate: any;
  feeds: any = []
  columns: any = [];
  colorMap: any = {};
  offsetMapping: any = {};
  isDataLoaded: boolean = false;
  tooltipOptions: any = {};
  feedSearch: any = {
    selectedOption: {},
    selectedFilter: {},
    placeholder: "Please search and select",
    options: [],
  }
  filterFrom: number = 0;
  filterLimit: number = 10;
  shouldShowFeedReset: boolean = false;
  defaultSelectedField: any = {};
  transactionTags: any = [];
  restrictedFields: any = {
    "phone_number": 1,
    "email_address": 1,
    "name": 1
  }
  showSearchList: boolean = false;
  showFilterFields: boolean = false;
  searchResult: any = {};
  clearField: any = {
    isError: false,
    displayText: 'clear',
    isEnabled: false
  }
  searchText: string = '';
  loggedManagerId: string = '';
  loggedManagerAccess: any = null;
  brandDetails: any = {};
  accountDetails: any = {};
  brandsMapping: any = {}
  filterSwitch: any = {
    "assign_to_me": false,
    "followed_by_me": false,
    "unread": false,
    "excluded_from_stats": false,
    "with_comment": false,
    "without_comment": false

  }
  isRoleBasedProject: boolean = false;
  pagingDetails: any = {
    start: 0,
    end: 0,
    pageSize: 10,
    pageNumber: 1,
    total: 0,
    totalpages: 1
  }
  pagingButtons: any = {
    isNext: false,
    isPrevious: false,
    isLast: false,
    isFirst: false
  }
  selectedProjectType: any = {};
  brandIds: any = [];
  isAccountLevelFeeds: boolean = false;
  isReloadEnd: boolean = true;
  // projects will receive from Api data
  projects: any = [];
  totalResponseCount = 0;
  feedView: string = 'list';
  feedIdList: any = [];
  feedDetailsView: any = {
    open: false,
    isNext: false,
  };
  isADRMOdalOpen: boolean = false;

  gridSortList: any = [{
    label: "Project Name (A-Z)",
    order: 'asc',
    field: 'name'
  }, {
    label: "Project Name (Z-A)",
    order: 'desc',
    field: 'name'
  }, {
    label: "Response Count (low to high)",
    order: 'asc',
    field: 'doc_count'
  }, {
    label: "Response Count (high to low)",
    order: 'desc',
    field: 'doc_count'
  }, {
    label: "Received Time (newest first)",
    order: 'desc',
    field: 'last_response_received_at_time'
  }, {
    label: "Received Time (oldest first)",
    order: 'asc',
    field: 'last_response_received_at_time'
  }]
  activeGridSort: any = {
    label: "Project Name (A-Z)",
    order: 'asc',
    field: 'name'
  }
  tableConfig: any = {
    isRowClickable: true,
    isExternalSort: true
  }
  isAgeSLATimerEnabled: boolean = false;
  isLoading: boolean = false;
  projectType: number = 0;
  totalProjectList: any = []
  searchItem: string = '';
  originalFeeds: any = [];
  isSearchPerformed: boolean = false;
  showNoProjectsMessage: boolean = false;
  searchBarConfig = {
    width: 275,
    placeholder: 'Search'
  };

  primaryQuestion: any = {};
  extenderRatingMapper = new extendedRaterFile();
  showScrollButtons: boolean = false;
  isReportDownloadAllowed: boolean = false;

  hierarchyStack: any = [];
  constructor(
    private _feedService: FeedsService,
    private _helpers: HelpersService,
    private _ltmsEvent: LtmsEventHandlerService,
    private _loginService: LoginService,
    private _accountService: AccountsService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _managersService: ManagersService,
    private _filterService: GlobalFilterService,
    private appStateService: AppStateService
  ) {
    // Added effect for Project type changed 
    effect(() => {
      if (this.appStateService.initialized()) {
        const state: any = this.appStateService.appState();
        const selectedProject: any = this.appStateService.projectType();
        // this.feedView = (this.isAccountFeeds) ? 'grid' : 'list';
        this.isReportDownloadAllowed = this._helpers.isReportDownloadEnabled();
        if(state?.hierarchyStack && state?.hierarchyStack?.length) {
          this.hierarchyStack = _.filter(state?.hierarchyStack,(hierarchy:any)=>{
            return (hierarchy?.field_id && hierarchy?.field_id  != 'touchpoints');
          });
        }else{
          this.hierarchyStack = [];
        }
        if (this.accountDetails && this.isAccountLevelFeeds && this.feedView == 'grid') {
          this.projectType = selectedProject?.project_type;
          this.filterBrandList()
        }
        this.fromDate = state.datePicker.startDate;
        this.toDate = state.datePicker.endDate;
        this.brandDetails = state.brandDetails;
        this.accountDetails = state.accountDetails;
        this.dateFilterType = state.datePicker.dateFilterType;
        this.pagingDetails = {
          start: 0,
          end: 0,
          pageSize: 10,
          pageNumber: 1,
          total: 0,
          totalpages: 1
        }
        this.pagingButtons = {
          isNext: false,
          isPrevious: false,
          isLast: false,
          isFirst: false
        }
        if (this.brandDetails) {
          this.setPossibleTransactionTag(this.brandDetails);
        }
        if (this.feedView == 'list')
          this.preparePreloadData();

        if (this.accountDetails && this.isAccountLevelFeeds && this.feedView == 'grid')
          this.loadResponseCountByproject();
      }
    });
  }

  ngOnInit(): void {
    this.feedView = (this.isAccountFeeds) ? 'grid' : 'list';
    if (!this.isAccountFeeds) {
      this.desclaimer = this.projectLevelDesclaimer;
    }
    // this._helpers.appState.pipe(
    //   takeUntilDestroyed(this.destroyRef),
    // ).subscribe((state: any) => {
    //   if (state && !state.pending) {
    //     this.fromDate = state.datePicker.startDate;
    //     this.toDate = state.datePicker.endDate;
    //     this.brandDetails = state.brandDetails;
    //     this.accountDetails = state.accountDetails;
    //     this.dateFilterType = state.datePicker.dateFilterType;
    //     this.pagingDetails = {
    //       start: 0,
    //       end: 0,
    //       pageSize: 10,
    //       pageNumber: 1,
    //       total: 0,
    //       totalpages: 1
    //     }
    //     this.pagingButtons = {
    //       isNext: false,
    //       isPrevious: false,
    //       isLast: false,
    //       isFirst: false
    //     }
    //     if (this.brandDetails) {
    //       this.setPossibleTransactionTag(this.brandDetails);
    //     }
    //     if (this.feedView == 'list')
    //       this.preparePreloadData();

    //     if (this.accountDetails && this.isAccountLevelFeeds && this.feedView == 'grid')
    //       this.loadResponseCountByproject();

    //   }

    // })
    this._ltmsEvent.remove('refresh-feed-list')
    this._ltmsEvent.listen('refresh-feed-list', () => {
      if (this.isAccountLevelFeeds) {
        this.getAccountFeedList()
      } else {
        this.getFeedList();
      }
    })

  }

  // Filter result based on project type.
  filterBrandList() {
    let afterFilterList: any = [];
    this.totalProjectList = this._feedService.totalProjectList;
    this.totalResponseCount = 0;

    // Get all projects that match the project type filter
    const filteredBrands = Helpers.brandListDetail.filter((ele: any) => {
      return (
        ele?.is_single_touchpoint_setup &&
        _.get(ele, 'show_on_dashboard') != false &&
        (this.projectType === 0 || ele?.project_type === this.projectType)
      );
    });

    // Map the filtered brands to their project data
    if (this.totalProjectList && this.totalProjectList.length > 0) {
      this.projects = this.totalProjectList.filter(brand => {
        const isDataFiltered = filteredBrands.some(p => p._id === brand['project_id']);
        if (isDataFiltered) {
          this.totalResponseCount += brand['doc_count'];
          return true;
        }
        return false;
      });
    } else {
      this.projects = [];
    }

    this.isDataLoaded = true;
    this.showNoProjectsMessage = this.projects.length === 0;
  }


  loadResponseCountByproject() {
    // console.log("Calling API ......")
    const parameters: any = {};
    this.isDataLoaded = false;
    parameters['account_id'] = this.accountDetails._id;
    parameters['from'] = this.fromDate;
    parameters['to'] = this.toDate;
    parameters['date_filter_type'] = this.dateFilterType;
    this._feedService.getFeedCountByprojectForAccountLevel(parameters).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((response: any) => {
      this.projects = [];
      this.totalResponseCount = 0;
      if (response && response['data']) {
        let projects = _.map(response['data'], (project: any) => {
          if (!project.name) {
            project.name = "Anonymous"
          }
          if (project.last_response_received_at) {
            project.last_response_received_at_time = new Date(project.last_response_received_at).getTime();
          } else {
            project.last_response_received_at = 'NA'
            project.last_response_received_at_time = null;
          }

          this.totalResponseCount = this.totalResponseCount + project['doc_count'];
          return project;
        });
        // this.projects = this.projects.concat(this.tempData)
        this.totalProjectList = _.orderBy(projects, [this.activeGridSort.field], [this.activeGridSort.order])
        this._feedService.totalProjectList = this.totalProjectList;
        this.filterBrandList()
        this.isDataLoaded = true;
      } else {
        this.projects = [];
        this.isDataLoaded = true;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.isAccountLevelFeeds = this.isAccountFeeds;
    if (this.isAccountFeeds) {
      this.feedView = 'grid';
    }
    this._route.queryParams.subscribe((params: any) => {
      this.isAccountLevelFeeds = (params && params['project_id']) ? false : true;
      if (this.isAccountLevelFeeds) {
        this.feedView = 'grid';
      }
    })
  }

  ngAfterViewInit(): void {
    document.addEventListener('click', (event) => {
      const litmusfeedsearchel: any = document.getElementById('litmusfeedsearch');
      if (litmusfeedsearchel && litmusfeedsearchel != event.target && !litmusfeedsearchel.contains(event.target)) {
        this.showFilterFields = false;
        this.showSearchList = false;
      }
      if (this.litmusfeedsearch && this.litmusfeedsearch.nativeElement !== event.target && !this.litmusfeedsearch.nativeElement.contains(event.target)) {
        this.showFilterFields = false;
        this.showSearchList = false;
      }
      if (this.isGridSortMenuOpen && this.ltmsgridsortdd.nativeElement !== event.target && !this.ltmsgridsortdd.nativeElement.contains(event.target)) {
        this.isGridSortMenuOpen = false;
      }
    });
    this.checkOverflow();
    window.addEventListener('resize', this.checkOverflow.bind(this));
    this.scrollLeft(); // Ensure scroll is at left on page reload
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.checkOverflow.bind(this));
    this.scrollLeft();
  }

  checkOverflow(): void {
    if (this.leftControls && this.leftControls.nativeElement) {
      const el = this.leftControls.nativeElement;
      this.showScrollButtons = el.scrollWidth > el.clientWidth;
    }
  }

  showFeedsby(event: any, filterBy: string) {
    event.preventDefault();
    this.pagingDetails = {
      start: 0,
      end: 0,
      pageSize: 10,
      pageNumber: 1,
      total: 0,
      totalpages: 1
    }
    this.filters["pageNumber"] = 1;
    // this.filters["interactionStatus"] = null;
    this.filters["lastAppliedFilter"] = null;
    this.filters.lastResetFilter = "interactionStatus";
    if (filterBy != 'unread') {
      // Only reset filters that are mutually exclusive with the new filter
      if (filterBy == 'followed_by_me') {
        // Reset assignee-related filters when applying follower filter
        this.filters["assignedToIds"] = [];
        this.filters["roleAssignedTo"] = [];
        this.filters["includeExcludedFeeds"] = false;
        this.filterSwitch.assign_to_me = false;
        this.filterSwitch.excluded_from_stats = false;

        if (!this.filterSwitch.followed_by_me) {
          this.filterSwitch.followed_by_me = true;
          if (!this.isRoleBasedProject) {
            this.filters.lastAppliedFilter = "followerIds";
            this.filters.lastResetFilter = "assignedToIds";
            this.filters["followerIds"] = [this.loggedManagerId];
            this.filters["rolesFollowedBy"] = [];
          } else {
            this.filters.lastAppliedFilter = "rolesFollowedBy";
            this.filters.lastResetFilter = "roleAssignedTo";
            this.filters["rolesFollowedBy"] = [this.loggedManagerAccess];
            this.filters["followerIds"] = [];
          }
        } else {
          this.filterSwitch.followed_by_me = false;
          // Restore previous values when turning off the filter
          this.filters["followerIds"] = [];
          this.filters["rolesFollowedBy"] = [];
        }
      } else if (filterBy == 'assign_to_me') {
        // Reset follower-related filters when applying assignee filter
        this.filters["followerIds"] = [];
        this.filters["rolesFollowedBy"] = [];
        this.filters["includeExcludedFeeds"] = false;
        this.filterSwitch.followed_by_me = false;
        this.filterSwitch.excluded_from_stats = false;

        if (!this.filterSwitch.assign_to_me) {
          this.filterSwitch.assign_to_me = true;
          if (!this.isRoleBasedProject) {
            this.filters.lastAppliedFilter = "assignedToIds";
            this.filters.lastResetFilter = "followerIds";
            this.filters["assignedToIds"] = [this.loggedManagerId];
            this.filters["roleAssignedTo"] = [];
          } else {
            this.filters.lastAppliedFilter = "roleAssignedTo";
            this.filters.lastResetFilter = "rolesFollowedBy";
            this.filters["roleAssignedTo"] = [this.loggedManagerAccess];
            this.filters["assignedToIds"] = [];
          }
        } else {
          this.filterSwitch.assign_to_me = false;
          // Restore previous values when turning off the filter
          this.filters["assignedToIds"] = [];
          this.filters["roleAssignedTo"] = [];
        }
      } else if (filterBy == 'excluded_from_stats') {
        // Reset assignee/follower filters when applying excluded from stats filter
        this.filters["assignedToIds"] = [];
        this.filters["roleAssignedTo"] = [];
        this.filters["followerIds"] = [];
        this.filters["rolesFollowedBy"] = [];
        this.filterSwitch.followed_by_me = false;
        this.filterSwitch.assign_to_me = false;

        if (!this.filterSwitch.excluded_from_stats) {
          this.filterSwitch.excluded_from_stats = true;
          this.filters["includeExcludedFeeds"] = true;
        } else {
          this.filterSwitch.excluded_from_stats = false;
          this.filters["includeExcludedFeeds"] = false;
        }

      }
    }

    if (filterBy == 'unread') {
      // this.filterSwitch.assign_to_me = false
      // this.filterSwitch.followed_by_me = false;
      // Reset Page Number

      // this.filters["interactionStatus"] = (this.filters["interactionStatus"] == null) ? "unread" : null;
      if (!this.filterSwitch.unread) {
        this.filterSwitch.unread = true;
        this.filters["interactionStatus"] = "unread";
        this.filters["lastAppliedFilter"] = "interactionStatus";
      } else {
        this.filterSwitch.unread = false;
        this.filters["interactionStatus"] = null;
        // this.filters["lastAppliedFilter"] = null;
        // this.filters.lastResetFilter = "interactionStatus";
      }
    }
    if (filterBy == 'with_comment') {
      this.filterSwitch.without_comment = false;
      if (!this.filterSwitch.with_comment) {
        this.filterSwitch.with_comment = true;
      } else {
        this.filterSwitch.with_comment = false;
      }
    }
    if (filterBy == 'without_comment') {
      this.filterSwitch.with_comment = false;
      if (!this.filterSwitch.without_comment) {
        this.filterSwitch.without_comment = true;
      } else {
        this.filterSwitch.without_comment = false;
      }
    }

    if (this.filterSwitch.followed_by_me || this.filterSwitch.assign_to_me) {
      this._filterService.hideHierarchyFilterFn(true)
    } else {
      this._filterService.hideHierarchyFilterFn(false)
    }
    if (this.isAccountLevelFeeds) {
      this.getAccountFeedList()
    } else {
      this.getFeedList();
    }
  }

  refreshFeedList() {
    this.isReloadEnd = false
    // this.filterSwitch.assign_to_me = false;
    // this.filterSwitch.followed_by_me = false;
    // this.filterSwitch.unread = false;
    // this.filters["assignedToIds"] = [];
    // this.filters["roleAssignedTo"] = [];
    // this.filters["includeExcludedFeeds"] = false;
    // this.filters["followerIds"] = [];
    // this.filters["rolesFollowedBy"] = [];
    // this.filters["interactionStatus"] = null;
    // this.filters["lastAppliedFilter"] = null;
    // this.filters.lastResetFilter = "interactionStatus";
    this.pagingDetails = {
      start: 0,
      end: 0,
      pageSize: 10,
      pageNumber: 1,
      total: 0,
      totalpages: 1
    }
    if (this.isAccountLevelFeeds) {
      this.getAccountFeedList()
    } else {
      this.getFeedList();
    }

  }

  changeFeedView(view: string) {
    this.feedView = view;
    if (this.feedView == 'list')
      this.preparePreloadData();

    if (this.accountDetails && this.isAccountLevelFeeds && this.feedView == 'grid')
      this.loadResponseCountByproject();
  }
  openADRModal() {
    if (!Helpers.isAccountManager) {
      this.isADRMOdalOpen = true;
    } else {
      Helpers.smallAlertBox("Error", "ADR is not supported for Account-level users. Please update your access to Project-level.", "error");
    }

  }
  closeADRModal() {
    this.isADRMOdalOpen = false;
  }


  paginateFeedList(pagingType: string) {
    if (pagingType == 'next') {
      this.pagingDetails["pageNumber"]++;
    } else if (pagingType == 'previous') {
      this.pagingDetails["pageNumber"]--;
    } else if (pagingType == 'first') {
      this.pagingDetails["pageNumber"] = 1;
    } else if (pagingType == 'last') {
      this.pagingDetails["pageNumber"] = this.pagingDetails.totalpages;
    }
    if (this.isAccountLevelFeeds) {
      this.getAccountFeedList();
    } else {
      this.getFeedList()
    }
  }
  onPageChange(event: any) {
    this.feedDetailsView.open = true;
    this.feedDetailsView.isNext = _.get(event, 'isNext', false);
    // this.filters["pageNumber"] = _.get(event, 'pageNumber', 1);
    this.pagingDetails.pageNumber = _.get(event, 'pageNumber', 1);
    if (this.isAccountLevelFeeds) {
      this.getAccountFeedList();
    } else {
      this.getFeedList()
    }

  }
  setPossibleTransactionTag(brandDetail) {
    if (!_.isEmpty(brandDetail)) {
      this.transactionTags = _.filter(brandDetail.field_definitions, (field) => {
        // if field Id is not restricted field(Tokenisation case)
        var shouldReturn = (field.search == true || field.inbox_search_enabled == true) && ((this.restrictedFields[field.field_id] && brandDetail.is_restrict_user_details != true) || (!this.restrictedFields[field.field_id]));
        if (shouldReturn && this.restrictedFields[field.field_id] && !this.defaultSelectedField) {
          this.defaultSelectedField = field;
          this.feedSearch.selectedFilter = field

        }
        return shouldReturn;
      });
      this.setDefaultSearch();
    }

  }

  setDefaultSearch() {
    this.defaultSelectedField = null;
    if (this.defaultSelectedField) {
      this.defaultSelectedField = this.defaultSelectedField;
      const fieldId = _.get(this.defaultSelectedField, 'field_id', 'NA');
      const fieldName = _.get(this.defaultSelectedField, 'name', 'NA')
      this.setupTagSearchFilter(fieldId, fieldName);
    } else {
      // If no default selected field then make first object as the default one
      var defaultToSet = this.transactionTags[0];
      if (defaultToSet) {
        this.defaultSelectedField = defaultToSet;
        this.feedSearch.selectedFilter = defaultToSet
        const fieldId = _.get(defaultToSet, 'field_id', 'NA');
        const fieldName = _.get(defaultToSet, 'name', 'NA')
        this.setupTagSearchFilter(fieldId, fieldName);
      }
    }
  }

  setupTagSearchFilter(fieldId: string, fieldName: string) {
    this["filters"]["searchType"] = null;
    this["filters"]["userId"] = null;
    let lastSelectedFieldIdByTag = fieldId;
    let lastSelectedFieldNameByTag = fieldName;

    this.feedSearch = {
      selectedOption: {},
      selecteFilter: {},
      placeholder: `Search by ${fieldName}`,
      searchfield: "search_text",
      options: [],
    }

  }

  getParametersByFilterType() {
    var order = 0;
    const type = this.defaultSelectedField.field_id;
    if (this.isTextStartsWithTag(type) || this.isTagCustomParameter(type)) {
      return {
        shop_id_list: this.filters["shopIds"],
        primary_rating_levels: this.filters["primaryRatingLevels"],
        status_id_list: this.filters["statusIds"],
        category_id_list: this.filters["categoryIds"],
        tag_id_list: this.filters["tagIds"],
        assigned_to_id_list: this.filters["assignedToIds"],
        brand_id: this.filters["brandId"] || this.brandDetails._id,
        group_id: this.filters["groupId"],
        shop_id: this.filters["shopId"],
        from: Helpers.datePicker.startDate,
        to: Helpers.datePicker.endDate,
        limit: this.filterLimit,
        is_publish: this.filters["isPublish"],
        comment_keyword: this.filters["commentKeyword"],
        comment_keyword_switch: this.filters["commentKeywordSwitch"],
        empty_comments_filter: this.filters["emptyCommentsFilter"],
        include_excluded_feeds: this.filters["includeExcludedFeeds"],
        date_filter_type: this.filters["dateFilterType"],
        page_number: 1,
        customer_name: null,
        user_id: this.filters["userId"],
        interaction_status: this.filters["interactionStatus"],
        field_id: this.filters["fieldId"],
        search_type: type,
        custom_filter_list: this.getCustomHierarchyFilters()
      }
    } else {
      return {
        brand_id: this.filters.brandId || this.brandDetails._id,
        search_type: type,
        from: this.getFilterFrom(1),
        limit: this.filterLimit,
        order: order,
        to_date: Helpers.datePicker.endDate,
        from_date: Helpers.datePicker.startDate,
        custom_filter_list: this.getCustomHierarchyFilters()
      };
    }
  }

  toggleSearchList() {
    this.showFilterFields = false;
    if (this.showSearchList) {
      this.showSearchList = false;
    } else {
      this.showSearchList = true;
      this.feedSearch.placeholder = this.feedSearch.placeholder;
      // this.searchText = '';
      this.searchResult = {
        options: [{
          'displayText': "Start typing to search.",
          'text': "Start typing to search.",
          'id': '',
          isError: true
        }]
      }
    }
  }

  getFeedSforSelectedFields(item: any) {
    if (!item.isError) {
      this.pagingDetails.pageNumber = 1
      if (item.id || item.user_id) {
        const selectedFilterType = this.defaultSelectedField.field_id
        if (this.isTextStartsWithTag(selectedFilterType)) {
          this.filters["searchType"] = selectedFilterType;
          this.filters["searchText"] = item.id;

        } else {
          this.filters["userId"] = item.id;
        }
        this.searchText = item.displayText || item.text;
        this.clearField.isEnabled = true;
        this.getFeedList()
      } else {
        this.filters["searchType"] = null
        this.filters["searchText"] = null;
        this.filters["userId"] = null;
        this.searchText = '';
        this.clearField.isEnabled = false;
        this.getFeedList()
      }
      this.showSearchList = false;
      this.showFilterFields = false;
    }
  }

  toggleFilterFieldList() {
    this.showSearchList = false;
    if (this.showFilterFields) {
      this.showFilterFields = false;
    } else {
      this.showFilterFields = true;
    }

  }

  changeFilterField(field: any) {
    this.defaultSelectedField = field;
    this.feedSearch.selectedFilter = field
    this.setupTagSearchFilter(field.field_id, field.name);
    this.showFilterFields = false;
    this.getFeedSforSelectedFields(this.clearField)

  }

  searchByTag(event: any) {
    const searchText = event.target.value;
    this.isLoading = true;
    if (searchText && searchText != "") {
      const fieldId = this.defaultSelectedField.field_id;
      const fiterType = (this.isTextStartsWithTag(fieldId) || this.isTagCustomParameter(fieldId)) ? 'feeds' : 'user'
      let param: any = this.getParametersByFilterType();
      param.search_text = searchText;
      let parameters: any = {}
      _.each(param, (value: any, key: string) => {
        if (!_.isEmpty(value)) {
          parameters[key] = value
        }
      });
      this._feedService.getFeedAndUserfilter(parameters, fiterType).pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((response: any) => {
        this.searchResult = this.processSerchResult(fieldId, response.data);
        this.isLoading = false;
      });
    } else {
      this.searchResult = {
        options: [{
          'displayText': "Start typing to search.",
          'text': "Start typing to search.",
          'id': '',
          isError: true
        }]
      }
      this.isLoading = false;
    }

  }

  getFilterFrom(pageNumber: number) {
    if (pageNumber) {
      // pageNumber not undefined: PageNumber Undefined refers to first page
      this.filterFrom = ((pageNumber - 1) * this.filterLimit) + 1;
    } else {
      this.filterFrom = 0;
    }
    return this.filterFrom;
  }

  processSerchResult(fieldId: string, data: any) {
    var searchResults: any = [{ name: '', user_id: null }];
    var isPagination = false;
    this.shouldShowFeedReset = true;
    if (data.code == 0) {
      // data can be in response to user data(eg. name, phone, email) or transaction data(tag_transaction_id etc)
      var options = data.data || data.feed;
      if (options && options.length) {
        searchResults = options;
        isPagination = (options.length < this.filterLimit) ? false : true;
      } else {
        searchResults = [{ name: 'No Results found', user_id: null, isError: true }];
        isPagination = false;
      }
    } else if (data.code == 4001) {
      // Something went wrong
      searchResults = [{ name: '', user_id: null, isError: true }];
    } else if (data.code == 4003) {
      // internal error, search type not supported
      searchResults = [{ name: 'Search type not supported', user_id: null, isError: true }];
    } else if (data.code == 5005) {
      // "Search not available"
      searchResults = [{ name: 'Search not available', user_id: null, isError: true }];
    } else if (data.code == 5000) {
      // "Unknown Exception, exception while performing search"
      searchResults = [{ name: 'Search not available', user_id: null, isError: true }];
    }

    return {
      options: _.map(searchResults, (item) => {
        if (this.isTextStartsWithTag(fieldId)) {
          if (item.feedback_request_data && !item.user_id) {
            return {
              'displayText': item.feedback_request_data[fieldId],
              'text': item.feedback_request_data[fieldId],
              'id': item.feedback_request_data[fieldId],
              isError: (item.isError) ? true : false
            }
          } else {
            return {
              'text': item.name,
              'id': item.user_id,
              isError: (item.isError) ? true : false
            }
          }
        } else {
          return {
            'displayText': item[fieldId],
            'text': (item['name'] ? item['name'] : '') + " " + (item["phone_number"] ? item["phone_number"] : '') + " " + (item["email_address"] ? item["email_address"] : ''),
            'id': item.user_id,
            isError: (item.isError) ? true : false
          }
        }
      }),
      pagination: {
        more: isPagination
      }
    }
  }

  /*
   * isTextStartsWithTag: Checks whether the text starts with "tag_" or not
   * @params{string} text: Text where tag_ need to be searched
   */
  isTextStartsWithTag(text) {
    // regular expression to check for tag_(it refers to transaction details)
    var searchPattern = new RegExp('^tag_');
    return searchPattern.test(text);
  }

  /*
   * isTagCustomParameter: Checks whether the text starts with "ltms_custom_field" or not
   * @params{string} text: Text where ltms_custom_field need to be searched
   */
  isTagCustomParameter(text) {
    // regular expression to check for ltms_custom_field(it refers to custom parameters)
    var searchPattern = new RegExp('^ltms_custom_field');
    return searchPattern.test(text);
  }
  preparePreloadData() {
    this.brandDetails = (!_.isEmpty(this.brandDetails)) ? this.brandDetails : Helpers.brandDetails;
    this.accountDetails = (!_.isEmpty(this.accountDetails)) ? this.accountDetails : Helpers.accountDetails;
    this.colorMap = {};
    this.setManagerDetails();
    if (this.isAccountLevelFeeds && this.accountDetails) {
      this.columns = this.getColumns(true)
      this.setBrandDetailsForAccount(this.accountDetails._id)
      this.getAccountFeedList()
    }
    if (!this.isAccountLevelFeeds && this.brandDetails) {
      this.brandsMapping[this.brandDetails._id] = this.brandDetails;
      this.isAgeSLATimerEnabled = (this.brandDetails && this.brandDetails.is_age_sla_timer_enabled) ? true : false;
      this.columns = this.getColumns(false)
      this.offsetMapping[this.brandDetails._id] = this._helpers.getBrandTimezoneDetails(this.brandDetails)
      if (_.get(this, 'brandDetails.detailed_feedback_items') && !_.isEmpty(this.brandDetails.detailed_feedback_items)) {
        this.colorMap[this.brandDetails._id] = this.getColorMap(this.brandDetails.detailed_feedback_items)
      }
      this.getFeedList();
    }
  }

  getColorMap(detailedFeedbackItems: any) {
    let mapping = {};
    if (!_.isEmpty(detailedFeedbackItems)) {
      const primaryRatingQuestion = _.find(detailedFeedbackItems, (question: any) => {
        return question.field_id == "primary_rating";
      })
      if (primaryRatingQuestion && primaryRatingQuestion.prop) {
        this.primaryQuestion = primaryRatingQuestion;
        _.each(primaryRatingQuestion.prop, (detail: any, key: string) => {
          mapping[key] = detail.active_color
        })
      }
    }
    return mapping;
  }

  setManagerDetails() {
    const brandId = (!_.isEmpty(this.brandDetails)) ? this.brandDetails._id : null;
    this.loggedManagerAccess = {}
    this.loggedManagerId = _.get(Helpers, 'managerDetails.manager._id', '');
    const accessList: any = _.get(Helpers, 'managerDetails.manager.manager_access', []);
    let access: any = null;
    if (brandId) {
      access = _.find(accessList, (access: any) => {
        return (access.brand_id == brandId && access.is_default_access)
      })
      if (_.isEmpty(access)) {
        const list = _.filter(accessList, (access: any) => {
          return (access.brand_id == brandId)
        })
        if (list.length) {
          access = list[0]
        }
      }
    }

    if (!_.isEmpty(access)) {
      const level: any = (_.get(access, 'access_key') && !_.isEmpty(access.access_key)) ? _.keys(access.access_key)[0] : null;
      if (level) {
        this.loggedManagerAccess = {
          "level": level,
          "value": (access.access_key[level] && access.access_key[level].values && access.access_key[level].values.length) ? access.access_key[level].values[0] : ""
        }
      }
    }

  }

  setBrandDetailsForAccount(accountId: string) {
    const brands = _.get(Helpers, 'brandListDetail', []);
    const brandcheck = brands.filter((ele: any) => { if (ele && ele['account_id'] && ele['account_id'] == accountId) { return ele; } })
    if (brandcheck && brandcheck.length > 0) {
      this.brandsMapping = {};
      this.brandIds = [];
      _.each(brands, (brand: any) => {
        if (brand && brand.project_info && brand.project_info.project_status && (brand.project_info.project_status.toString() == "1" || brand.project_info.project_status.toString() == "2")) {
          this.colorMap[brand._id] = this.getColorMap(brand.detailed_feedback_items)
          this.brandsMapping[brand._id] = brand;
          this.brandIds.push(brand._id)
        }
      });
    } else {
      this._accountService.getBrandsList(accountId).pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((response: any) => {
        if (response.code == 0) {
          const brands = response.data.brands || [];
          this.brandsMapping = {};
          this.brandIds = [];
          _.each(brands, (brand: any) => {
            if (brand && brand.project_info && brand.project_info.project_status && (brand.project_info.project_status.toString() == "1" || brand.project_info.project_status.toString() == "2")) {
              this.colorMap[brand._id] = this.getColorMap(brand.detailed_feedback_items)
              this.brandsMapping[brand._id] = brand;
              this.brandIds.push(brand._id)
            }
          })
        }
      });
    }
  }



  getFeedList() {
    this.isDataLoaded = false;
    this.feedIdList = []
    this.getParametersForAPI((params) => {
      // delete some keys & values for comment filter
      let paramsObj = _.cloneDeep(params);
      if (paramsObj["universalFilter"] && paramsObj["universalFilter"]["action_filter"] && paramsObj["universalFilter"]["action_filter"]["comment"]) {
        delete paramsObj["universalFilter"]["action_filter"]["comment"]["selected_values"];
        delete paramsObj["universalFilter"]["action_filter"]["comment"]["details"];
      }
      this._feedService.getFeedsByFilter(paramsObj).pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((response) => {
        if (response.code == 0 && _.get(response, 'data.feed') && !_.isEmpty(response.data.feed)) {
          this.processFeedData(response.data)
          this.originalFeeds = [...this.feeds];
        } else {
          this.feeds = []
          this.isDataLoaded = true;
          this.isReloadEnd = true;
        }
      });
    })
  }

  getAccountFeedList() {
    this.isDataLoaded = false;
    this.feedIdList = [];
    var apiParams = this.getApiParamsForAccount(this.filters);

    this._feedService.getAccontFeedList(apiParams).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((response: any) => {
      if (response.code == 0 && _.get(response, 'data.feed') && !_.isEmpty(response.data.feed)) {
        this.processFeedData(response.data, this.accountDetails);
        this.totalProjectList = [...this.projects];
      } else {
        this.feeds = []
        this.isDataLoaded = true;
        this.isReloadEnd = true;
      }
    })
  }

  getAllStatusForHide(statusArray: any) {
    var counttemp: number = 0;
    var arraylength: number = statusArray.length;
    var allhiddenStatuses: any = []
    while (counttemp < arraylength) {
      var statusTemp = statusArray[counttemp]["hide_slaTimer_for_status"];
      var hideStatus = (statusTemp == true || statusTemp == false) ? statusTemp : null;

      if ((!(hideStatus == null)) && (hideStatus == true)) {
        allhiddenStatuses.push(statusArray[counttemp]["uuid"]);
      }
      counttemp++;
    }

    return allhiddenStatuses;
  }

  processFeedData(feeddata: any, details?: any) {
    this.feedIdList = [];
    const feedList = _.get(feeddata, 'feed', []);
    const managersMap = this.getHashMapbyKey(_.get(feeddata, 'managers', []), '_id');
    const shopsMap = this.getHashMapbyKey(_.get(feeddata, 'shops', []), '_id');
    const usersMap = this.getHashMapbyKey(_.get(feeddata, 'users', []), '_id');
    const brands = _.get(feeddata, 'brands', {})
    if (!_.isEmpty(brands)) {
      this.updateBrandMapping(brands);
    }

    const timestamp_sla_v3 = _.get(feeddata, 'timestamp_sla_v3');
    const total_feeds = _.get(feeddata, 'total_feeds');
    if (feedList.length) {
      this.feeds = _.map(feedList, (feed: any) => {
        var feedCreatedDate = Helpers.deepClone(feed["created_date"]);
        var isClosedListAvailable: boolean = false;

        if (this.brandsMapping[feed.brand_id]) {
          feed["brandDetail"] = this.brandsMapping[feed.brand_id];
          if (this.brandsMapping[feed.brand_id].lw_status_list_map) {
            isClosedListAvailable = (this.brandsMapping[feed.brand_id].lw_status_list_map && this.brandsMapping[feed.brand_id].lw_status_list_map.LW_CLOSED) && (this.brandsMapping[feed.brand_id].lw_status_list_map.LW_CLOSED.length > 0);
          }
          var isStatusListAvailable = (feed.status_id_list && feed.status_id_list.length > 0);
          var TATinhours = this.brandsMapping[feed.brand_id] ? (this.brandsMapping[feed.brand_id].action_management_configuration ? (this.brandsMapping[feed.brand_id].action_management_configuration.ageing_config ? (this.brandsMapping[feed.brand_id].action_management_configuration.ageing_config.turnaround_time ? (this.brandsMapping[feed.brand_id].action_management_configuration.ageing_config.turnaround_time) : null) : null) : null) : null;
          var slaSwitch = this.brandsMapping[feed.brand_id].is_age_sla_timer_enabled ? this.brandsMapping[feed.brand_id].is_age_sla_timer_enabled : false;
          if (slaSwitch) {
            var hideStatusArray = this.getAllStatusForHide(this.brandsMapping[feed.brand_id].status_list);
            var tobehidden = hideStatusArray.includes(feed.status_id_list[0]);
            var feedCreationDateCorrection = feedCreatedDate;
            if (!feedCreatedDate.includes("Z")) {
              feedCreationDateCorrection = feedCreationDateCorrection + "Z";
            }
            if (isStatusListAvailable && (TATinhours != null)) {
              if (isClosedListAvailable) {
                if (_.hasIn(feed, 'brandDetail.lw_status_list_map.LW_CLOSED') && feed.brandDetail.lw_status_list_map.LW_CLOSED.includes(feed.status_id_list[0])) {
                  feed["finalans"] = "";
                } else {
                  if (tobehidden) {
                    feed["finalans"] = "";
                  } else {
                    this.calculateSLATime(feedCreationDateCorrection, feed, this.brandsMapping[feed.brand_id], timestamp_sla_v3);
                  }
                }
              } else {
                if (feed.status_id_list.includes("c71a8524-7fc4-49d3-894a-2555dcc6ed07")) { // closed feed
                  feed["finalans"] = "";
                } else {
                  if (tobehidden) {
                    feed["finalans"] = "";
                  } else {
                    this.calculateSLATime(feedCreationDateCorrection, feed, this.brandsMapping[feed.brand_id], timestamp_sla_v3);
                  }
                }
              }
            }
          }
          let feedDetails: any = Helpers.deepClone(feed);
          let primaryRating = _.get(feed, 'feed_params.primary_rating', null)
          // Check if the question is of a specific component type and if extended rater type is 4
          if (this.primaryQuestion?.component_type == 'ltms-nps-five-star-rater' && Helpers.brandDetails?.extended_rater_type === 4 && (!_.isEmpty(Helpers.brandDetails.extended_rating_mapper))) {
            // Get the updated distribution using dynamic mapping logic
            primaryRating = this.extenderRatingMapper.getExtendedRaterMappingPrimaryRating(primaryRating, this.primaryQuestion);
          }
          let primaryRatingColor = _.get(this.colorMap, feed.brand_id + "." + _.get(feed, 'feed_params.primary_rating'), '#00000033');
          if (_.isNull(feed.feed_params.primary_rating)) {
            primaryRating = 'NA';
            primaryRatingColor = '#00000033'
          }
          let slaFormatedDate = this._helpers.getTimeByOffset(this.offsetMapping[feed.brand_id]["__zone_symbol__value"]['offset'], _.get(feed, 'finalans'), "DD MMM 'YY HH:mm");
          let lastUpdatedDate = null;

          if (feed["last_feed_updated_date"]) {
            lastUpdatedDate = feed["last_feed_updated_date"];
          } else if (feed.last_updated_at) {
            lastUpdatedDate = (new Date(feedCreatedDate).getTime() > new Date(feed.last_updated_at).getTime()) ? feedCreatedDate : feed.last_updated_at;
          } else {
            lastUpdatedDate = feedCreatedDate;
          }
          feedDetails = _.assign(feedDetails, {
            primary_rating: primaryRating,
            comments: (_.get(feed, 'feed_params.comments')) ? _.get(feed, 'feed_params.comments') : '',
            created_date: this._helpers.getTimeByOffset(this.offsetMapping[feed.brand_id]["__zone_symbol__value"]['offset'], _.get(feed, 'created_date'), "DD MMM 'YY HH:mm"),//moment(_.get(feed, 'created_date')).format('DD MMM 'YY hh:mm'),
            created_date_timestamp: moment(_.get(feed, 'created_date')).valueOf(),
            last_updated_at: this._helpers.getTimeByOffset(this.offsetMapping[feed.brand_id]["__zone_symbol__value"]['offset'], lastUpdatedDate, "DD MMM 'YY HH:mm"),
            last_updated_at_timestamp: moment(lastUpdatedDate).valueOf(),
            status_name: _.get(feed, 'status_details.0.name'),
            collapsableFields: ['comments'],
            due_date: (feed['finalans'] && feed['finalans'] !== "")
              ? moment(_.get(feed, 'finalans')).format("DD MMM 'YY HH:mm")
              : "",//moment(_.get(feed, 'finalans')).format('DD-MMM-YY hh:mm'),
            due_date_timestamp: moment(_.get(feed, 'finalans')).valueOf(),
            user_name: _.get(feed, "feedback_request_data.tag_private_user_name") || _.get(usersMap, feed.feed_by_id + '.name') || 'Anonymous',
            shop_name: this.getTouchpointName(_.get(shopsMap, feed.feed_target_id + '.name', "NA"), feed.litmus_processed_data || feed.feedback_request_data, this.brandsMapping[feed.brand_id]),
            project_name: _.get(this.brandsMapping, feed.brand_id + '.name', "NA"),
            coloMap: {
              primary_rating: primaryRatingColor,
              due_date: _.get(feed, 'finalanscolor')
            }
          })
          return feedDetails
        } else {
          return {}
        }

      });

      this.feeds = this.feeds.map((feed) => {
        if (feed.primary_rating === 'NA') {
          return {
            ...feed,
            tooltip_text: {
              primary_rating: 'No rating provided by the customer'
            }
          }
        }
        return feed
      })
      this.feedIdList = _.map(this.feeds, (feed) => feed._id)
    }
    this.updatePagingDetails(total_feeds, this.pagingDetails.pageNumber)
    if (this.feedDetailsView.open) {
      const feedId = (this.feedDetailsView.isNext) ? this.feedIdList[0] : this.feedIdList[this.feedIdList.length - 1];
      const data: any = {
        row: {
          _id: feedId
        }
      };
      this.showFeedDetails(data)
      this.feedDetailsView.open = false;
    }

    this.isDataLoaded = true;
    this.isReloadEnd = true;
  }

  updateBrandMapping(brands: any) {
    this.brandsMapping = {}
    this.colorMap = {}

    if (!_.isEmpty(brands)) {
      _.each(brands, (brand: any) => {
        this.brandsMapping[brand._id] = brand;
        this.offsetMapping[brand._id] = this._helpers.getBrandTimezoneDetails(brand)
        this.colorMap[brand._id] = this.getColorMap(brand.detailed_feedback_items)
      })
    }
  }

  updatePagingDetails(totalfeeds: number, pageNumber: number) {
    if (totalfeeds > this.pagingDetails.pageSize) {
      pageNumber = (pageNumber > 0) ? pageNumber : 1;
      let start = (pageNumber > 0) ? ((pageNumber - 1) * this.pagingDetails.pageSize) + 1 : 1;
      let end = (pageNumber > 0) ? (pageNumber * this.pagingDetails.pageSize) : this.pagingDetails.pageSize;
      end = (pageNumber >= this.pagingDetails.totalpages) ? ((pageNumber - 1) * this.pagingDetails.pageSize) + this.feeds.length : end;
      this.pagingDetails = {
        start: start,
        end: end,
        pageSize: 10,
        pageNumber: pageNumber,
        total: totalfeeds,
        totalpages: Math.ceil(totalfeeds / 10)
      }
    } else {
      this.pagingDetails = {
        start: (totalfeeds > 0) ? 1 : 0,
        end: (totalfeeds > 0) ? totalfeeds : 0,
        pageSize: 10,
        pageNumber: 1,
        total: (totalfeeds > 0) ? totalfeeds : 0,
        totalpages: 1
      }
    }
    this.pagingDetails.total = totalfeeds;
    this.pagingButtons.isNext = false;
    this.pagingButtons.isFirst = false;
    this.pagingButtons.isPrevious = false;
    this.pagingButtons.isLast = false;

    if (this.pagingDetails.pageNumber < this.pagingDetails.totalpages) {
      this.pagingButtons.isNext = true;
      this.pagingButtons.isLast = true;
    }

    if (this.pagingDetails.pageNumber > 1) {
      this.pagingButtons.isFirst = true;
      this.pagingButtons.isPrevious = true;
    }

    if (this.pagingDetails.total < this.pagingDetails.pageSize) {
      this.pagingButtons.isNext = false;
      this.pagingButtons.isFirst = false;
      this.pagingButtons.isPrevious = false;
      this.pagingButtons.isLast = false;
    }
  }

  /**
   * calculateSLATime: SLA timer that categorizes feeds in 2 categories namely, overdue and timely based on the TAT configured.
   */
  calculateSLATime(feedCreatedDate, feed, brandDetail, timestamp_sla_v3) {

    var TATinhours = brandDetail.action_management_configuration.ageing_config.turnaround_time;
    var businessTimeMin = Helpers.finalTimeInMinForSLA(brandDetail, feedCreatedDate, timestamp_sla_v3);
    if ((!(businessTimeMin == "Invalid dates passed")) && (!(businessTimeMin == "Error: TimeStamp Invalid"))) {

      var finalDateForClosure = Helpers.getSlaClosureFinalDate(brandDetail, feedCreatedDate, timestamp_sla_v3)

      if (!(finalDateForClosure == "Error: TimeStamp Invalid") && !(finalDateForClosure == "Error: No TAT Available")) {
        var finalTimeInMin = ((TATinhours * 60) - businessTimeMin);
        var properStringSLA = Helpers.getProperStringSLA(finalTimeInMin);
        // Tooltip hover requirement
        this.tooltipOptions = {
          forsla: true
        };
        if (finalTimeInMin == 0) {
          feed["finalans"] = finalDateForClosure;
          feed["closureDateData"] = [
            { 'label': '', 'rated': "SLA status: within SLA" }
          ];
          feed["finalanscolor"] = "green";
        } else {
          // overdue
          if (finalTimeInMin < 0) {
            feed["finalans"] = finalDateForClosure;
            feed["finalanscolor"] = "red";
            feed["closureDateData"] = [
              { 'label': '', 'rated': "SLA status: SLA breached" }
            ];
          } else { //remaining
            feed["finalans"] = finalDateForClosure;
            feed["finalanscolor"] = "green";
            feed["closureDateData"] = [
              { 'label': '', 'rated': "SLA status: within SLA" }
            ];
          }
        }
      }
    }
  }

  getParametersForAPI(cb) {
    // this.filters
    var isRoleBasedProject = _.get(this.brandDetails, "action_management_configuration.isRoleBasedAssignee") || false;
    var roleAssignedTo = _.get(this, "filters.roleAssignedTo") ? _.get(this, "filters.roleAssignedTo") : [];
    var rolesFollowedBy = _.get(this, "filters.rolesFollowedBy") ? _.get(this, "filters.rolesFollowedBy") : [];
    var getFromEs = false;
    if (roleAssignedTo.length || rolesFollowedBy.length) {
      getFromEs = true;
    }
    var filters: any = {
      accountId: (_.isObject(this.accountDetails) && !_.isEmpty(this.accountDetails)) ? this.accountDetails._id : null,
      shopIds: Helpers.allTouchPointsSelected != false ? Helpers.shopIdList : null, // This is not getting used in the API
      primaryRatingLevels: [], // Array of primary rating to filter the feed by primary rating(Example: if primary_rating_levels have 1 and 2 then it return the feeds which have primary rating 1 or 2).
      statusIds: this.getFilter('status'), // Status id Array
      tatStatusClosed: this.getFilter('tat_status_closed'), // TAT Status for feeds
      categoryIds: this.getFilter('category'), // Category id Array
      tagIds: this.getFilter('tag'), // tag id Array
      /** Setting the below parameters assignedToIds and followerIds with null as those will be the part of global filters and will be in universalFilter*/
      assignedToIds: _.get(this, "filters.assignedToIds"), // Assignee Id Array
      followerIds: _.get(this, "filters.followerIds"),
      brandId: null,
      groupId: null,
      shopId: null,
      from: this.fromDate,
      to: this.toDate,
      limit: _.get(this, "filters.limit") || this.limit,
      isPublish: null, // Not in use. This was to show published feedbacks.
      commentKeyword: null, // Not in use. This was for filtering out feeds on basis of this keyword if comment_keyword = 'better' then it return those feed who have the 'better' keyword in comments or detailed_rating.comment(based on the comment_keyword_switch)
      commentKeywordSwitch: _.get(this, "filters.includePrimaryComments") || 1, // Filter through comment(primary, non-primary comment), 1: Primary Comment 2: Non Primary comment
      emptyCommentsFilter: this.getCommentFilter(), // To filter either by empty or non-empty comment or both
      includeExcludedFeeds: this.getStatsFilter(), // To filter by the feeds which are excluded from stats
      dateFilterType: this.dateFilterType || _.get(this, "filters.dateFilterType") || 2, // sort date by request or response date. Default Sort through created_date
      dataSortOrder: _.get(this, "filters.dataSortOrder") || 'desc',
      userId: _.get(this, "filters.userId") || null, // Not used in feed count 
      interactionStatus: _.get(this, "filters.interactionStatus"), // Not used in feed count
      fieldId: _.get(this, "filters.fieldId"), // Not in use
      searchType: _.get(this, "filters.searchType") || null, // Not used in feed count
      searchText: _.get(this, "filters.searchText") || null, // Not used in feed count
      isFilterByHistory: null, // Not used in feed count
      customFilterList: this.getCustomHierarchyFilters(), // Not used in feed count
      hierarchyFilterDetailsList: (this.hierarchyStack && this.hierarchyStack.length) ? this.hierarchyStack : [],
      textV2Status: _.get(this, "filters.textV2Status") || false,
      // If ES enabled or textV2Status enabled then get data from ES
      dataSource: !(!(_.isEmpty(Helpers.universalFilter)) || _.get(this, "filters.textV2Status") || (getFromEs && isRoleBasedProject)) ? 1 : 2,
      universalFilter: this.getUniversalFilter(Helpers.universalFilter),
      is_service_management: _.get(this, "filters.is_service_management") || false, //flag to identify if the project is service management
      roleAssignedTo: roleAssignedTo,
      rolesFollowedBy: rolesFollowedBy
    }

    if (filters.tatStatusClosed && filters.tatStatusClosed.length > 0) {
      filters.consideredClosedStatus = _.get(Helpers, "brandDetails.lw_status_list_map.LW_CLOSED") || _.get(this, "brandDetails.lw_status_list_map.LW_CLOSED");
      filters.TAThours = _.get(Helpers, "brandDetails.action_management_configuration.ageing_config.turnaround_time") || _.get(this, "brandDetails.action_management_configuration.ageing_config.turnaround_time");

      var actionableArray = [];
      actionableArray = _.get(Helpers, "brandDetails.action_management_configuration.actionables") || _.get(this, "brandDetails.action_management_configuration.actionables");
      var finalActionableArray = [];
      if (actionableArray && actionableArray.length > 0) {

        finalActionableArray = this.getActionableRatings(actionableArray);
        var ageTypeForTAT = _.get(Helpers.brandDetails, "action_management_configuration.ageing_config.type");
        filters.age_type = ageTypeForTAT ? ageTypeForTAT : 1;
        filters.actionableRatings = finalActionableArray;
      }
    }

    if (_.get(this, "pagingDetails.pageNumber") > 1) {
      filters['pageNumber'] = _.get(this, "pagingDetails.pageNumber"); // Not used in feed count
    } else {
      filters['pageNumber'] = 1;
    }

    if (filters.searchText || filters.searchType) {
      filters.dataSource = 2;
    }
    if (Helpers.touchpointId) {
      filters["shopId"] = Helpers.touchpointId;
    } else if (_.get(this, "params.brandId")) {
      filters["brandId"] = _.get(this, "params.brandId")
    } else {
      filters["brandId"] = _.get(this, "brandDetails._id");
    }

    // Requirement Change: If assignedToIds or followerIds exists then pass brand id to assignee_follower_brand_id
    if (_.get(this, "filters.assignedToIds.length") || _.get(this, "filters.followerIds.length") || _.get(this, "filters.roleAssignedTo.length") || _.get(this, "filters.rolesFollowedBy.length")) {
      filters["assigneeFollowerBrandId"] = _.get(this, "brandDetails._id");
    }

    // To filter either by empty or non-empty comment
    if (_.isEmpty(filters["universalFilter"]["action_filter"])) {
      filters["universalFilter"]["action_filter"] = {};
    }

    // Handle comment filters - mutually exclusive
    const commentFilterKey = "comment";

    // Clear any existing comment filter first
    if (filters["universalFilter"]["action_filter"][commentFilterKey]) {
      delete filters["universalFilter"]["action_filter"][commentFilterKey];
    }
    if (filters["emptyCommentsFilter"]) {
      delete filters["emptyCommentsFilter"];
    }

    // Apply new comment filter based on switch state
    if (this.filterSwitch["with_comment"] === true) {
      filters["emptyCommentsFilter"] = 2;
      filters.dataSource = 2;
      filters["universalFilter"]["action_filter"][commentFilterKey] = {
        "action": "eq",
        "values": [2],
        "selected_values": "With Comments",
        "details": [{ value: 2, text: "With Comments" }]
      };
    } else if (this.filterSwitch["without_comment"] === true) {
      filters["emptyCommentsFilter"] = 3;
      filters.dataSource = 2;
      filters["universalFilter"]["action_filter"][commentFilterKey] = {
        "action": "eq",
        "values": [3],
        "selected_values": "Without Comments",
        "details": [{ value: 3, text: "Without Comments" }]
      };
    }
    this.filters = filters
    cb(filters);
  }

  getApiParamsForAccount(filters) {
    var searchType = _.get(this.filters, "searchType");
    var searchText = _.get(this.filters, "searchText");
    var apiParams: any = {
      account_id: this.accountDetails._id,
      from: Helpers.datePicker.startDate,
      to: Helpers.datePicker.endDate,
      assigned_to_id_list: (!_.isEmpty(this.filters.assignedToIds)) ? _.get(this, "filters.assignedToIds") : null,
      followers_id_list: (!_.isEmpty(this.filters.followerIds)) ? _.get(this, "filters.followerIds") : null,
      data_source: 2,
      date_filter_type: filters.dateFilterType || 2,
      date_sort_type: (filters.dataSortOrder && (filters.dataSortOrder.indexOf("asc") > -1)) ? "response_asc" : "response_desc",
      date_sort_order: filters.dataSortOrder,
      page_number: this.pagingDetails.pageNumber,
      limit: this.pagingDetails.pageSize,
      project_type: _.get(Helpers, "projectType.project_type"),
      brandIdList: (searchType && searchText) ? this.brandIds : null,
      interaction_status: _.get(this.filters, "interactionStatus", null),
    }
    if (this.selectedProjectType && this.selectedProjectType.type) {
      apiParams.project_type = this.selectedProjectType.type
    }

    return apiParams;
  }

  getUniversalFilter(universalFilter) {
    var filter = universalFilter || {};
    if (!_.isEmpty(universalFilter) && !_.isEmpty(universalFilter["action_filter"])) {
      filter = Helpers.deepClone(universalFilter);
      _.each(filter["action_filter"], (value, key) => {
        delete value["details"];
        delete value["selected_values"];
        delete value["filterName"];
        // If this.filters contains assignedToIds then merge it universal filter's assignee list
        if (key == "assigned_to_id_list") {
          var assignToMeId = _.get(this, "filters.assignedToIds") || [];

          // Merging Universal filter assignee list with assign to me id
          value["values"] = (_.get(value, "values.length")) ? value["values"].concat(assignToMeId) : assignToMeId;
        }
      })
    }
    return filter;
  }

  getFilter(type: string) {
    var list = [];
    var filterDetail = _.get(Helpers, "universalFilter." + this.univeralFilterMap[type]);
    // Every filter will must action(such as eq, ne) and value(list of uuid or id etc)
    if (_.get(filterDetail, "action") && _.get(filterDetail, "values.length")) {
      if (filterDetail["action"] == "eq") {
        list = filterDetail["values"];
      } else if (filterDetail["action"] == "ne") {
        // Filter out list element which are deleted and not disabled
        var elemInBrandDetail = _.filter(_.get(this.brandDetails, this.brandFilterMap[type]["key"]), (elem) => {
          if (elem["is_deleted"] != true && elem["is_enabled"] != false) {
            return elem;
          }
        })
        var listInBrand = _.map(elemInBrandDetail, this.brandFilterMap[type]["uniqueField"]);
        list = _.difference(listInBrand, filterDetail["values"]);
      }
    }
    return list;
  }

  getCommentFilter() {
    var filter = _.get(Helpers, "universalFilter.action_filter.comment.values");
    // Default has to be 1(include with and without comments), 2: with comment, 3: without comments
    return (filter) ? filter : 1;
  }

  /**
   * getStatsFilter: Returns filter value to either include the feeds which are excluded from the stastics or to exclude them.
   *                  - Possible values are:  
   *                      : true - to fetch feeds which are excluded from the stats
   *                      : false - to fetch feeds which are not excluded from the stats
   *                  - Default is false(Include feeds which are excluded from Stats).
   */
  getStatsFilter() {
    var shouldInclude = _.get(this.filters, "includeExcludedFeeds");
    return (shouldInclude == true || shouldInclude == false) ? shouldInclude : false;
  }

  getCustomHierarchyFilters() {
    var hierarchyFilters: any = [];
    // this.brandDetails = (this.brandDetails) ? this.brandDetails : Helpers.brandDetails;
    if (this.brandDetails && this.brandDetails.is_single_touchpoint_setup && this.hierarchyStack && this.hierarchyStack.length) {
      _.each(this.hierarchyStack, function (hierarchy) {
        if (hierarchy.field_id && hierarchy.group_key && hierarchy.group_key.length) {
          hierarchyFilters.push({
            "field": hierarchy.field_id,
            "value": hierarchy.group_key[0]
          })
        } 

      })
    }
    return hierarchyFilters;
  }

  getActionableRatings(actionableArray) {
    var currentDate = new Date();
    var actionablesLength = actionableArray.length;
    for (var actionableArrayCount = 0; actionableArrayCount < actionablesLength; actionableArrayCount++) {
      if (actionableArray[actionableArrayCount]["date"]["start"] && actionableArray[actionableArrayCount]["date"]["end"]) {
        var minDate = new Date(actionableArray[actionableArrayCount]["date"]["start"]);
        var maxDate = new Date(actionableArray[actionableArrayCount]["date"]["end"]);

        if (currentDate >= minDate && currentDate <= maxDate) {
          return actionableArray[actionableArrayCount]["primary_rating"];
        }
      } else if (actionableArray[actionableArrayCount]["date"]["start"] && !actionableArray[actionableArrayCount]["date"]["end"]) {
        var minDate = new Date(actionableArray[actionableArrayCount]["date"]["start"]);
        var maxDate = currentDate;

        if (currentDate >= minDate && currentDate <= maxDate) {
          return actionableArray[actionableArrayCount]["primary_rating"];
        }

      }
    }
  }

  getColumns(isAccount: boolean) {
    const ratingColumn = {
      header: 'Rating',
      dataKey: 'primary_rating',
      dataType: "number",
      enabled: true,
      componentType: 'badges',
      sortingEnabled: false,
      style: {
        headerAlign: 'center',
        cellTextAlign: 'center',
        width: "10%"
      },
      order: 1
    }
    const responseColumn = {
      header: 'Feedback',
      dataKey: 'comments',
      dataType: "string",
      componentType: 'collapsable',
      ellipsisEnabled: true,
      maxChar: 20,
      enabled: true,
      clickable: true,
      sortingEnabled: false,
      descriptionFields: ["user_name", "shop_name", "feedback_reference_token"],
      style: {
        headerAlign: 'left',
        cellTextAlign: 'left',
        width: "60%"
      },
      order: 2,
    }
    const recievedColumn = {
      header: 'Received on',
      dataKey: 'created_date',
      dataType: "string",
      sortBy: 'created_date_timestamp',
      enabled: true,
      isColumnSorted: true,
      sorted: true,
      style: {
        headerTextAlign: 'left',
        cellTextAlign: 'left',
        width: "20%"
      },
      order: 3
    }
    const updateDateColumn = {
      header: 'Updated on',
      dataKey: 'last_updated_at',
      dataType: "string",
      sortBy: 'last_updated_at_timestamp',
      enabled: true,
      sortingEnabled: false,
      style: {
        headerAlign: 'left',
        cellTextAlign: 'left',
        width: "20%"
      },
      order: 4
    }
    const dueDateColumn = {
      header: 'Due',
      dataKey: 'due_date',
      dataType: "string",
      enabled: true,
      // componentType:'status',
      sortingEnabled: false,
      style: {
        headerAlign: 'left',
        cellTextAlign: 'left',
        width: "20%"
      },
      order: 5
    }
    const statusColumn = {
      header: 'Status',
      dataKey: 'status_name',
      dataType: "string",
      enabled: true,
      // componentType:'status',
      sortingEnabled: false,
      style: {
        headerTextAlign: 'left',
        cellTextAlign: 'left',
        width: "15%"
      },
      order: (isAccount) ? 2 : 6
    }
    const projectColumn = {
      header: 'Projects',
      dataKey: 'project_name',
      dataType: "string",
      enabled: true,
      // componentType:'status',
      sortingEnabled: false,
      style: {
        headerTextAlign: 'left',
        cellTextAlign: 'left',
        width: "20%"
      },
      order: 7
    }
    if (isAccount) {
      return [ratingColumn, responseColumn, statusColumn, recievedColumn, projectColumn];
    } else {
      if (this.isAgeSLATimerEnabled) {
        return [ratingColumn, responseColumn, recievedColumn, updateDateColumn, dueDateColumn, statusColumn];
      } else {
        return [ratingColumn, responseColumn, recievedColumn, updateDateColumn, statusColumn];
      }
    }

  }

  showFeedDetails(event: any) {
    this._ltmsEvent.emit('feed-detail-panel', {
      feed_id: event.row._id,
      feedIdList: (this.feedIdList.length) ? this.feedIdList : [],
      pagingDetails: this.pagingDetails
    })
  }

  getTouchpointName(defaultName, tags, brand) {
    if (brand && brand.is_single_touchpoint_setup == true) {

      try {
        var levels: any = [];
        var maxLevel = 0;
        var maxLevelValue = defaultName;
        _.each(tags, (value: any, key: string) => {
          if (key.indexOf('tag_private_group_h_') >= 0 && value && value.length) {
            var level = parseInt((key.replace('tag_private_group_h_', "").replace('_', "")));
            if (level > maxLevel) {
              maxLevel = level;
            }
            levels.push({
              "value": value[0],
              "level": level
            })
          }
        })
        maxLevel = maxLevel - 1
        const touchpoint = _.find(levels, { level: maxLevel });
        return touchpoint.value;

      } catch (e) {
        return defaultName;
      }

    } else {
      return defaultName;
    }
    return defaultName;
  }

  getHashMapbyKey(list: any, key: string) {
    let map: any = {};
    if (!_.isEmpty(list)) {
      _.each(list, (item: any) => {
        map[item[key]] = item;
      })
    }
    return map;
  }
  isGridSortMenuOpen: boolean = false;
  openGridSortMenu(event: any) {
    event.preventDefault()
    this.isGridSortMenuOpen = !this.isGridSortMenuOpen
  }
  sortProjects(event: any, data: any) {
    event.preventDefault();
    this.activeGridSort = data;
    this.isGridSortMenuOpen = false;
    this.projects = _.orderBy(this.projects, [data.field], [data.order])
  }

  navigetToProject(event: any, project: any) {
    event.preventDefault();
    this._managersService.setCurrentLoggedInManager(this.accountDetails._id, project.project_id).subscribe((reponse: any) => {
      if (this._helpers.helpers['managerDetails']['last_synced_details']) {
        delete this._helpers.helpers['managerDetails']['last_synced_details'];
        window['Helpers'] = this._helpers.consoleData();
      }
      this._router.navigate(['account/project/inbox'], {
        queryParams: {
          account_id: this.accountDetails._id,
          project_id: project.project_id
        }
      });
    })
  }
  // this is for future use
  isFullscreen: boolean = false;
  toggleFullscreen(event: any, templateRef: TemplateRef<any> | null) {
    event.preventDefault()
    if (this.isFullscreen) {
      this.isFullscreen = false;
      this.fullScreenComponent = null;
    } else {
      this.isFullscreen = true;
      this.fullScreenComponent = templateRef
    }
  }
  sortFeedList(event: any) {
    if (event) {
      const sortOrder = (!event.sorted) ? 'asc' : 'desc'
      this.columns = _.map(this.columns, (column: any) => {
        if (column.dataKey == event.dataKey) {
          column.isColumnSorted = true;
          column.sorted = event.sorted;
          column.sortingEnabled = true;
        } else {
          delete column.isColumnSorted;
          delete column.sorted;
        }
        return column;
      })
      //TODO: update sorting functionality to enable sort on all table columns
      if (event.dataKey != 'created_date') {
        const field = (event.sortBy) ? event.sortBy : event.dataKey;
        this.feeds = _.orderBy(this.feeds, [field], [sortOrder]);
        this.feedIdList = _.map(this.feeds, (feed: any) => feed._id)
      } else {
        this.filters.dataSortOrder = sortOrder;
        if (this.isAccountLevelFeeds) {
          this.getAccountFeedList()
        } else {
          this.getFeedList();
        }
      }

    }

  }

  searchData(event: any) {
    this.searchItem = event;
    this.isSearchPerformed = true;

    if (!this.searchItem) {
      this.isSearchPerformed = false;
      this.filterBrandList(); // Reset to filtered list based on project type
      return;
    }

    const searchTerm = this.searchItem.toLowerCase();
    let filteredProjects = this.totalProjectList;

    // First apply project type filter
    if (this.projectType !== 0) {
      filteredProjects = filteredProjects.filter((project: any) => {
        const brand = Helpers.brandListDetail.find((b: any) => b._id === project.project_id);
        return brand?.project_type === this.projectType;
      });
    }

    // Then apply search filter
    this.projects = filteredProjects.filter((project: any) => {
      return project.name.toLowerCase().includes(searchTerm);
    });

    // Recalculate total response count
    this.totalResponseCount = this.projects.reduce((sum: number, project: any) => sum + project.doc_count, 0);
  }

  scrollLeft() {
    if (this.leftControls && this.leftControls.nativeElement) {
      this.leftControls.nativeElement.scrollBy({ left: -99999, behavior: 'smooth' });
      setTimeout(() => this.checkOverflow(), 350);
    }
  }

  scrollRight() {
    if (this.leftControls && this.leftControls.nativeElement) {
      this.leftControls.nativeElement.scrollBy({ left: 99999, behavior: 'smooth' });
      setTimeout(() => this.checkOverflow(), 350);
    }
  }
}
